/**
 * Devuelve la expresión limpiada del "label" que podría tener opcionalmente.
 * El label es un string con ":" al principio de una instrucción.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/label
 * No lo usamos tal cual, pero sirve para distinguir expresiones de simple string en el view.
 *
 * @param {string} expression
 * @returns {string}
 */
export function cleanLabelFromExpression(expression) {
  if (typeof expression === 'string') {
    return expression.replace(/^[\$a-zA-Z0-9_]*:/, '').trim();
  }

  return '';
}
